export var SHOW_HOTSPOTS = 'SHOW_HOTSPOTS';
export var HIDE_HOTSPOTS = 'HIDE_HOTSPOTS';
export var FLASH_HOTSPOTS = 'FLASH_HOTSPOTS';
export var LOAD_HOTSPOTS_STARTING = 'LOAD_HOTSPOTS_STARTING';
export var LOAD_HOTSPOTS_DONE = 'LOAD_HOTSPOTS_DONE';
export var LOAD_HOTSPOTS_FAILED = 'LOAD_HOTSPOTS_FAILED';
export var ADD_TO_HOVER_STACK = 'ADD_TO_HOVER_STACK';
export var REMOVE_FROM_HOVER_STACK = 'REMOVE_FROM_HOVER_STACK';
export var HOVER_OUT = 'HOVER_OUT';
